import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useReminderParent = (parentType, parentId, rootId, config) => {
  let url = "";

  switch (parentType) {
    case "Task": {
      url = `${Angie.api_url}/projects/${rootId}/tasks/${parentId}`;
      break;
    }
    case "Note": {
      url = `${Angie.api_url}/projects/${rootId}/notes/${parentId}`;
      break;
    }
    case "Discussion": {
      url = `${Angie.api_url}/projects/${rootId}/discussions/${parentId}`;
      break;
    }
    case "CalendarEvent": {
      url = `${Angie.api_url}/calendars/${rootId}/events/${parentId}`;
      break;
    }
  }

  return useQuery({
    ...config,
    queryKey: ["reminder-parent", parentType, parentId, rootId],
    queryFn: ({ signal }) =>
      fetch({
        url,
        prefetchNext: true,
        signal,
      }),
  });
};

export const useReminderRoot = (parentType, rootId, config) => {
  let url = "";

  switch (parentType) {
    case "Task": {
      url = `${Angie.api_url}/projects/${rootId}`;
      break;
    }
    case "Note": {
      url = `${Angie.api_url}/projects/${rootId}`;
      break;
    }
    case "Discussion": {
      url = `${Angie.api_url}/projects/${rootId}`;
      break;
    }
    case "CalendarEvent": {
      url = `${Angie.api_url}/calendars/${rootId}`;
      break;
    }
  }

  return useQuery({
    ...config,
    queryKey: ["reminder-root", parentType, rootId],
    queryFn: ({ signal }) =>
      fetch({
        url,
        prefetchNext: true,
        signal,
      }),
  });
};
